import React, { memo } from 'react';
import { ThemedSpinner } from '@atlassian/jira-project-theme-components/src/ui/ThemedSpinner.tsx';
import type { Column, TableProps } from '../../../../common/types/base-table.tsx';
import type { ListViewControllerData } from '../../../../controllers/list-view-issues/types.tsx';
import {
	LoadingField,
	LoadingIcon,
	LoadingWrapper,
	LoadingRow,
	SpinnerWrapper,
	TableWrapper,
	Wrapper,
	ICON_OFFSET,
} from './styled.tsx';

const getRowSkeleton = (
	columns: Array<Column<ListViewControllerData>>,
	rowHeight: undefined | number,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	SkeletonRow: any,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	SkeletonField: any,
	key = 0,
) => (
	<SkeletonRow key={key}>
		{columns.map((column) => (
			<SkeletonField key={column.key} height={rowHeight} width={column.width} />
		))}
	</SkeletonRow>
);

const getLoadingSkeleton = (
	columns: Array<Column<ListViewControllerData>>,
	rowHeight: undefined | number,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	SkeletonRow: any,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	SkeletonField: any,
) =>
	Array.from({ length: 20 }, (_, i) =>
		getRowSkeleton(columns, rowHeight, SkeletonRow, SkeletonField, i),
	);

export const LoadingTable = memo<TableProps<ListViewControllerData>>(
	({ columns, rowHeight }: TableProps<ListViewControllerData>) => (
		<Wrapper>
			{columns.length ? (
				<TableWrapper>
					<LoadingRow key="loading-header-row">
						{columns.map((column) => (
							<LoadingWrapper key={column.key}>
								<LoadingIcon />
								<LoadingField
									// @ts-expect-error - Type 'number | undefined' is not assignable to type 'number'.
									height={rowHeight}
									width={column.width - ICON_OFFSET}
								/>
							</LoadingWrapper>
						))}
					</LoadingRow>
					{getLoadingSkeleton(columns, rowHeight, LoadingRow, LoadingField)}
				</TableWrapper>
			) : (
				<SpinnerWrapper>
					<ThemedSpinner />
				</SpinnerWrapper>
			)}
		</Wrapper>
	),
	(prevProps, nextProps) => prevProps.columns.length === nextProps.columns.length,
);
